import { api } from "./api";

export const holidaysList = async (addUrl = '') => {
  return await api.get(`holidays/list?${addUrl}`);
};

export const holidaysCreate = async (data) => {
  return await api.post('holidays/create', data);
};

export const holidaysUpdate = async (data) => {
  return await api.post('holidays/update', data);
};

export const holidaysDetails = async (id) => {
  return await api.get(`holidays/details?id=${id}`);
};

export const holidaysDelete = async (id) => {
  return await api.post(`holidays/delete`, { id });
};

export const holidaysStatus = async (data) => {
  return await api.post(`holidays/status/change`, data);
};

export const holidaysSendMessage = async (id) => {
  return await api.post("/holidays/send/message", { id });
};

export const leavesRequests = async (addUrl = ``) => {
  return await api.get(`/leaves/request/list?${addUrl}`);
};

export const leavesRequestDelete = async (id) => {
  return await api.post(`leaves/request/delete`, { id });
};

export const leaveStatusUpdate = async (data) => {
  return await api.post('/leaves/status/change', data);
};